module.exports = __webpack_public_path__ + "static/img/head-instruction.db7d6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/head-instruction.png
// module id = ajkU
// module chunks = 1